module.exports = __webpack_public_path__ + "img/chat_bubble.png";